import { APP_ENV } from '@modules/consts';

const getLogoSrc = (): string[] => {
    switch (APP_ENV) {
        case 'puppet-interview':
            return ['/puppet-interview-horiz.png']; // Use the horizontal version from public assets
        case 'crest':
            return ['/USAID_Horizontal.png', '/CREST-logo.png']; // Use the horizontal versions from public assets
        case 'sabol':
            return ['/chate-horizontal.png']; // Use the horizontal version from public assets
        default:
            return ['/puppet-interview-horiz.png']; // Default to puppet interview logo
    }
};

const getLogoAlt = () => {
    switch (APP_ENV) {
        case 'puppet-interview':
            return 'Puppet Interview Logo';
        case 'crest':
            return 'CREST Logo';
        case 'sabol':
            return 'CHAT-E Logo';
        default:
            return 'Logo';
    }
};

export default function SidebarLogo() {
    return (
        <div style={{ padding: '.5rem', textAlign: 'center' }}>
            {getLogoSrc().map((src, index) => (
                <img
                    key={src}
                    src={src}
                    alt={getLogoAlt()}
                    style={{
                        maxWidth: '100%',
                        maxHeight: '60px',
                        // USAID wants their logo to be larger than other logos
                        ...(index > 0 && { maxWidth: '80%' }),
                    }}
                />
            ))}
        </div>
    );
}
